import React from 'react'
import { Row, Col, InputGroup, Input, Label, FormGroup } from 'reactstrap';
import { Menu, MenuItem, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert'

const customOptions = [
    {
        Name: "@model.BPNAME",
        Description: {
            en: "BP Name"
        }
    },
    {
        Name: "@model.BPNUMBER",
        Description: {
            en: "BP Number"
        }
    },
    {
        Name: "@model.BPCNUMBER",
        Description: {
            en: "BPC Number"
        }
    },
    {
        Name: "@model.BPSNUMBER",
        Description: {
            en: "BPS Number"
        }
    },
    {
        Name: "@model.Company",
        Description: {
            en: "Company"
        }
    },
    {
        Name: "@model.Currency",
        Description: {
            en: "Currency"
        }
    },
    {
        Name: "@model.Description",
        Description: {
            en: "Description"
        }
    },
    {
        Name: "@model.DocumentID",
        Description: {
            en: "Document Ref"
        }
    },
    {
        Name: "@model.DocumentType",
        Description: {
            en: "Document Type"
        }
    },
    {
        Name: "@model.OrderRef",
        Description: {
            en: "Order Ref"
        }
    },
    {
        Name: "@model.Pages",
        Description: {
            en: "Pages"
        }
    },
    {
        Name: "@model.TransactionDate",
        Description: {
            en: "Transaction Date"
        }
    },
    {
        Name: "@model.TransactionNumber",
        Description: {
            en: "Transaction Number"
        }
    },
    {
        Name: "@model.TransactionType",
        Description: {
            en: "Transaction Type"
        }
    },
    {
        Name: "@model.TransactionValue",
        Description: {
            en: "Transaction Value"
        }
    },
    {
        Name: "@model.UserName",
        Description: {
            en: "User Name"
        }
    } 
];

const EmailSubject = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [inputCursor, setInputCursorLocation] = React.useState(0);
    const open = Boolean(anchorEl);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemSelect = (value) => {
        let subject = props.subject.substr(0, inputCursor) + value + props.subject.substr(inputCursor)
        props.setSubject(subject, props.filterTemplates);
        handleClose();
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Row form>
            <Col>
                <FormGroup>
                    <InputGroup>
                        <Label for="type" className="s-field-title s-anchored">Subject</Label>
                        <Input
                            type="text"
                            value={props.subject}
                            name="subject"
                            onMouseUp={(e) => setInputCursorLocation(e.target.selectionStart)}
                            onKeyUp={(e) => setInputCursorLocation(e.target.selectionStart)}
                            onChange={(e) => props.setSubject(e.target.value, props.filterTemplates)}
                        />
                        <IconButton
                            color="#3c424f"
                            aria-controls="menu"
                            aria-haspopup="true"
                            size="small"
                            onClick={handleClick}
                        >
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="menu"
                            anchorEl={anchorEl}
                            open={open}
                            keepMounted
                            onClose={handleClose}
                            PaperProps={{
                                style: {
                                    maxHeight: 48 * 4.5,
                                    width: 200,
                                },
                            }}
                        >
                            {customOptions && customOptions.map(option => (
                                <MenuItem key={option.Name} onClick={() => handleMenuItemSelect(option.Name)}>
                                    {option.Description['en']}
                                </MenuItem>
                            )).sort()}

                            {props.options && props.options.map(option => (
                                <MenuItem key={option.Name} onClick={() => handleMenuItemSelect('@model.DocumentData.' + option.Name)}>
                                    {option.Description['en']}
                                </MenuItem>
                            )).sort()}
                        </Menu>
                    </InputGroup>
                </FormGroup>
            </Col>
        </Row>
    )
}

export default EmailSubject;